import { useLocation } from 'react-router-dom';

/**
 * Retrieves the current section name from the URL.
 * For example, if the URL is '/clients/13/details?service=abc', then it returns 'details'.
 */
export function useSection(): string | undefined {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    return pathSegments[2];
}